import { Component, OnInit, Input } from '@angular/core'; 
import { Subscription } from 'rxjs'; 

@Component({
    selector: 'app-range-table',
    templateUrl: './range-table.component.html',
    styleUrls: ['./range-table.component.scss'],
    standalone: false
})
export class RangeTableComponent implements OnInit {

  @Input()
  valueForRangeTable;

  @Input()
  valueForRangeTableCL;

  public data = [];
  table = {
    titles: [{
      type: $localize`:@@js_type:Tipo`,
      name: $localize`:@@js_name:Nombre`,
      score: "Score",
      quantityReg: $localize`:@@js_quantity:Cantidad`
    }],
  }
  dataLoaded: boolean = false;
  public keysRange = [];
  subscriptions: Subscription[] = [];

  tableDataCL: Map<string, number[]> = new Map();
  totalsCL;
  averagesCL;

  constructor() { 
    // Empty Constructor
  }


  ngOnChanges(): void {
    if(this.valueForRangeTableCL){
      this.getRangeDataCL();
      this.calculateTotalsAndAverageCL();
    } else if(this.valueForRangeTable) {
      this.getRangeData(this.valueForRangeTable);
    } else {
      this.dataLoaded = true;
    }
  }

  ngOnInit() {
    // This method is not implemented
  }

  async getRangeData(response) {
    this.data = [];
    this.data = response;
    this.data?.forEach(period => {
      this.keysRange = Object.keys(period.rangeValues);
    })
    this.keysRange.sort((a, b) => {
      const A_LABEL_ARR = a.split("-");
      const B_LABEL_ARR = b.split("-");
      return Number(A_LABEL_ARR[0]) - Number(B_LABEL_ARR[0]);
    }) 
    this.data?.sort((a, b) => {
      const A_LABEL_ARR = a.periodString.split("-");
      const B_LABEL_ARR = b.periodString.split("-");
      return Number(B_LABEL_ARR[1]) - Number(A_LABEL_ARR[0]);
    }) 
    this.dataLoaded = true;
  }

  withDecimal(score: any) {
    if (score) {
      return score;
    } else {
      return "0.00";
    }
  }

  getRangeDataCL(){
    this.tableDataCL = new Map();
    this.valueForRangeTableCL.periods?.forEach(
      period => {
        this.valueForRangeTableCL.rangeValues?.forEach(
          range => {
            const valueObj = period.values.find(v => v.range === range);
            if(!this.tableDataCL.has(range)){
              this.tableDataCL.set(range, [])
            }
            this.tableDataCL.get(range)?.push(valueObj ? valueObj.quantity : 0)
          }
        )
      }
    )
    this.dataLoaded = true;
  }

  calculateTotalsAndAverageCL(){
    const periodCounts = this.valueForRangeTableCL?.periods?.map(() => 0);
    const periodSums = this.valueForRangeTableCL?.periods?.map(() => 0);

    this.valueForRangeTableCL.rangeValues?.forEach(
      range => {
        this.tableDataCL.get(range)?.forEach(
          (qty, index) => {
            periodSums[index] += qty;
            if(qty > 0){
              periodCounts[index]++;
            }
          }
        )
      }
    );
    this.totalsCL = periodSums;
    this.averagesCL = periodSums?.map(
      (sum, index) => {
        return periodCounts[index] > 0 ? sum / periodCounts[index] : 0;
      }
    );
  }
}
